import InvitesAPI from 'js/api/invites'

export default {
    /** 共通 **/
   // loadListObj ({commit}, data) {
   //     commit('setListObjLoadStatus', 1)

   //     InvitesAPI.loadListObj(data)
   //         .then(resp => {
   //             commit('setListObj',resp)
   //             commit('setListObjLoadStatus', 2)
   //         })
   //         .catch(err => {
   //             commit('setListObj', {})
   //             commit('setListObjLoadStatus', 3)
   //         })
   // },

   // resetListObj ({commit}) {
   //     commit('resetListObj')
   // },
   // setListObjKeep ({commit}) {
   //     commit('setListObjKeep')
   // },
   // backListFromKeep ({commit}) {
   //     commit('backListFromKeep')
   // },
   // loadListObjSeeMore ({commit}, data) {
   //     commit('setListObjSeeMoreLoadStatus', 1)

   //     InvitesAPI.loadListObjSeeMore(data)
   //         .then(resp => {
   //             commit('setListObjAddSeeMore',resp)
   //             commit('setListObjSeeMoreLoadStatus', 2)
   //         })
   //         .catch(err => {
   //             commit('setListObjSeeMoreLoadStatus', 3)
   //         })
   // },

    /** ポイント取得 **/
    loadPoint ({commit}) {
        commit('setPointLoadStatus', 1)

        InvitesAPI.loadPoint()
            .then(resp => {
                commit('setPoint',resp)
                commit('setPointLoadStatus', 2)
            })
            .catch(err => {
                commit('setPoint', {})
                commit('setPointLoadStatus', 3)
            })
    },

    /** 招待情報取得 **/

    loadInviteInfo ({commit}, data) {
        commit('setInviteInfoLoadStatus', 1)

        InvitesAPI.loadInviteInfo(data)
            .then(resp => {
                commit('setInviteInfo',resp)
                commit('setInviteInfoLoadStatus', 2)
            })
            .catch(err => {
                commit('setInviteInfo', {})
                commit('setInviteInfoLoadStatus', 3)
            })
    },

    resetInviteInfo ({commit}) {
        commit('resetInviteInfo')
    },

    loadCompanys ({commit}) {
        commit('setCompanysLoadStatus', 1)

        InvitesAPI.loadCompanys()
            .then(resp => {
                commit('setCompanys',resp)
                commit('setCompanysLoadStatus', 2)
            })
            .catch(err => {
                commit('setCompanys', {})
                commit('setCompanysLoadStatus', 3)
            })
    },

    delCompany ({commit, dispatch}, data) {
        commit('setDelCompanyStatus', 1)

        InvitesAPI.delCompany(data)
            .then(resp => {
                commit('setDelCompanyStatus', 2)
                dispatch('loadCompanyDetail', {group: data.group})
            })
            .catch(err => {
                commit('setDelCompanyStatus', 3)
            })
    },

    addCompany ({commit, dispatch}, data) {
        commit('setAddCompanyStatus', 1)

        InvitesAPI.addCompany(data)
            .then(resp => {
                dispatch('loadCompanys')
                commit('setAddCompanyStatus', 2)

            })
            .catch(err => {
                commit('setAllErrors', err.response.data.errors)
                commit('setAddCompanyStatus', 3)
            })
    },

    saveCompanyInfo ({commit,dispatch}, data) {
        commit('resetCompanyOperat')
        commit('setSaveCompanyInfoStatus', 1)

        InvitesAPI.saveCompanyInfo(data)
            .then(resp => {
                commit('setCompanyOperat', 'success')
                commit('setCompanyInfo', resp)
                commit('setSaveCompanyInfoStatus', 2)

            })
            .catch(err => {
                commit('setSaveCompanyInfoStatus', 3)
            })
    },

    shareInviteCode ({commit}, data) {
        commit('setShareInviteCodeStatus', 1)

        InvitesAPI.shareInviteCode(data)
            .then(resp => {
                commit('setAllErrors', {})
                commit('setShareInviteCodeStatus', 2)
            })
            .catch(err => { 
                commit('setAllErrors', err.response.data.errors)
                commit('setShareInviteCodeStatus', 3)
            })
    },

    loadCompanyDetail ({commit}, data) {
        commit('setCompanyDetailLoadStatus', 1)

        InvitesAPI.loadCompanyDetail(data)
            .then(resp => {
                commit('setCompanyDetail',resp)
                commit('setCompanyDetailLoadStatus', 2)
            })
            .catch(err => {
                commit('setCompanyDetail', {})
                commit('setCompanyDetailLoadStatus', 3)
            })
    },

    resetCompanyDetail ({commit}) {
        commit('resetCompanyDetail')
    },

    companyInviteDetailChange ({commit, dispatch}, data) {
        commit('setCompanyInviteDetailChangeStatus', 1)

        InvitesAPI.companyInviteDetailChange(data)
            .then(resp => {
                commit('setCompanyInviteDetailChangeStatus', 2)
                dispatch('loadCompanyDetail', {group: data.group})
            })
            .catch(err => {
                commit('setCompanyInviteDetailChangeStatus', 3)
            })
    },

    loadTechLevel ({commit}) {
        commit('setTechLevelLoadStatus', 1)

        InvitesAPI.loadTechLevel()
            .then(resp => {
                commit('setTechLevel',resp)
                commit('setTechLevelLoadStatus', 2)
            })
            .catch(err => {
                commit('setTechLevel', {})
                commit('setTechLevelLoadStatus', 3)
            })
    },

    resetTechLevel ({commit}) {
        commit('resetTechLevel')
    },

    loadTechChild ({commit}, data) {
        commit('setTechChildLoadStatus', 1)

        InvitesAPI.loadTechChild(data)
            .then(resp => {
                commit('setTechChild',resp)
                commit('setTechChildLoadStatus', 2)
            })
            .catch(err => {
                commit('setTechChild', {})
                commit('setTechChildLoadStatus', 3)
            })
    },

    resetTechChild ({commit}) {
        commit('resetTechChild')
    },

    /** 履歴書一覧 **/
    loadTechResume ({commit}, data) {
        commit('setTechResumeLoadStatus', 1)

        InvitesAPI.loadTechResume(data)
            .then(resp => {
                commit('setTechResume', resp)
                commit('setTechResumeLoadStatus', 2)
            })
            .catch(err => {
                commit('setTechResume', {})
                commit('setTechResumeLoadStatus', 3)
            })
    },

    setTechResumeListSession ({commit}) {
        commit('setTechResumeListSession')   
    },

    /** 履歴書配信Flg更新 **/
    changeTechResumeMailFlg ({commit}, data) {
        commit('setChangeTechResumeMailFlgStatus', 1)

        InvitesAPI.changeTechResumeMailFlg(data)
            .then(resp => {
                if (resp.data.tech) {
                    commit('updateTechResume', resp.data.tech)
                }
                commit('setChangeTechResumeMailFlg', resp)
                commit('setChangeTechResumeMailFlgStatus', 2)
            })
            .catch(err => {
                commit('setChangeTechResumeMailFlgStatus', 3)
            })
    },

    /** 受信日最新化 **/
    updateTechResumeRecentInDay ({commit}, data) {
        commit('setUpdateTechResumeRecentInDayStatus', 1)
        commit('setTechResumeHasChangeForInputBarStatus', 1)

        InvitesAPI.updateTechResumeRecentInDay(data)
            .then(resp => {
                if (resp.data.tech) {
                    commit('updateTechResume', resp.data.tech)
                }
                commit('setUpdateTechResumeRecentInDay', resp)
                commit('setUpdateTechResumeRecentInDayStatus', 2)
                commit('setTechResumeHasChangeForInputBarStatus', 2)
            })
            .catch(err => {
                commit('setUpdateTechResumeRecentInDayStatus', 3)
            })
    },

    /** 個別送信後、画面送信時間更新 **/
    changeTechResumeSpecifyOutTime({commit},data) {
        commit('changeTechResumeSpecifyOutTime', data)
    },

    /** 履歴書削除 **/
    deleteTechResume ({commit}, data) {
        commit('setDeleteTechResumeStatus', 1)
        commit('setTechResumeHasChangeForInputBarStatus', 1)

        InvitesAPI.deleteTechResume(data)
            .then(resp => {
                commit('deleteTechResumeFromList', data.id)
                commit('setDeleteTechResumeStatus', 2)
                commit('setTechResumeHasChangeForInputBarStatus', 2)
            })
            .catch(err => {
                commit('setDeleteTechResumeStatus', 3)
            })
    },

    /** 履歴書作成・更新 **/
    saveResumeInfo ({commit}, data) {
        commit('resetResumeOperat')
        commit('setSaveResumeInfoStatus', 1)

        InvitesAPI.saveResumeInfo(data)
            .then(resp => {
                commit('setAllErrors', {})
                commit('setResumeOperat', 'success')
                commit('setResumeInfo', resp)
                commit('updateTechResume', resp.data.resume)
                commit('setSaveResumeInfoStatus', 2)
            })
            .catch(err => {
                commit('setResumeOperat', data.operat)
                commit('setAllErrors', err.response.data.errors)
                commit('setSaveResumeInfoStatus', 3)
            })
    },

    /** 履歴書詳細 **/
    loadResumeInfo ({commit}, data) {
        commit('setResumeInfoLoadStatus', 1)

        InvitesAPI.loadResumeInfo(data)
            .then(resp => {
                commit('setResumeInfo', resp)
                commit('setResumeInfoLoadStatus', 2)
            })
            .catch(err => {
                commit('setResumeInfo', {})
                commit('setResumeInfoLoadStatus', 3)
            })
    },

    loadPersonInfo ({commit}, data) {
        commit('setPersonInfoLoadStatus', 1)

        InvitesAPI.loadPersonInfo(data)
            .then(resp => {
                commit('setPersonInfo',resp)
                commit('setPersonInfoLoadStatus', 2)
            })
            .catch(err => {
                commit('setPersonInfo', {})
                commit('setPersonInfoLoadStatus', 3)
            })
    },
    
    resetPersonInfo ({commit}) {
        commit('resetPersonInfo')
    },

    identityOk ({commit, dispatch}, data) {
        commit('setIdentityOkStatus', 1)

        InvitesAPI.identityOk(data)
            .then(resp => {
                commit('setIdentityOkStatus', 2)
                dispatch('loadPersonInfo', data)

            })
            .catch(err => {
                commit('setIdentityOkStatus', 3)
            })
    },

    identityNg ({commit, dispatch}, data) {
        commit('setIdentityNgStatus', 1)

        InvitesAPI.identityNg(data)
            .then(resp => {
                commit('setIdentityNgStatus', 2)
                dispatch('loadPersonInfo', data)

            })
            .catch(err => {
                commit('setIdentityNgStatus', 3)
            })
    },

    loadLatestPointInfo ({commit}) {
        commit('setLatestPointInfoLoadStatus', 1)

        InvitesAPI.loadLatestPointInfo()
            .then(resp => {
                commit('setLatestPointInfo',resp)
                commit('setLatestPointInfoLoadStatus', 2)
            })
            .catch(err => {
                commit('setLatestPointInfo', {})
                commit('setLatestPointInfoLoadStatus', 3)
            })
    },

    makePoint ({commit}, data) {
        commit('setMakePointStatus', 1)

        InvitesAPI.makePoint(data)
            .then(resp => {
                commit('setAllErrors', {})
                commit('setLatestPointInfo',resp)
                commit('setMakePointStatus', 2)
            })
            .catch(err => {
                commit('setAllErrors', err.response.data.errors)
                commit('setMakePointStatus', 3)
            })
    },

    payStatus ({commit}, data) {
        commit('setPayStatusChangeStatus', 1)

        InvitesAPI.payStatus(data)
            .then(resp => {
                commit('setPayStatusChangeItem', resp)
                commit('setPayStatusChangeStatus', 2)
            })
            .catch(err => {
                commit('setPayStatusChangeItem', {})
                commit('setPayStatusChangeStatus', 3)
            })
    },

}
